import { Recurly } from '@recurly/recurly-js';
import { onGlobalVarSet } from '@mm/utils';

const getRecurly = (): Promise<Recurly> => {
  return onGlobalVarSet<Recurly>('recurly', { maxPollNumber: 100 });
};

export { getRecurly };
